// A user-entered website as a safe link target. http(s) passes through, a bare
// host ("www.x.com") gets https://, anything else (javascript:, data:) is null
// so it renders as plain text, never as a clickable script (KIN-91). The server
// validates on save too; this covers values saved before that check existed.
export const safeHref = (url) => {
  const value = typeof url === "string" ? url.trim() : "";
  if (!value) return null;
  if (/^https?:\/\//i.test(value)) return value;
  if (/^[a-z][a-z0-9+.-]*:/i.test(value)) return null;
  return `https://${value}`;
};
